import React from "react";
import StaffProfileDropdown from "../../common/StaffProfileDropdown";
import StaffProfileDropdownWithFreeText from "../../common/StaffProfileDropdownWithFreeText";
import MultiSelectDropdown from "../../common/MultiSelectDropdown";
import MultiSelectWithFreeText from "../../common/MultiSelectWithFreeText";
import CustomDateTimePicker from "../../common/CustomDateTimePicker";

const WorkPermissionsAvailabilitySection = ({
  isEditing,
  formData,
  handleInputChange,
  fifaCountries,
  contractStatusOptions,
  clubOptions,
  willingnessOptions,
  regionOptions,
}) => {
  return (
    <div className="bg-white p-6 border border-[#E6E6E6]">
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-[11px] font-bold text-[#3C3C3C] tracking-wider">
          WORK PERMISSIONS & AVAILABILITY
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Passport held
          </label>
          <MultiSelectDropdown
            value={formData.passportHeld}
            onChange={(value) => handleInputChange("passportHeld", value)}
            options={fifaCountries}
            placeholder="Select countries..."
            disabled={!isEditing}
            className="w-full"
          />
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Work Permits
          </label>
          <MultiSelectWithFreeText
            value={formData.workPermits}
            onChange={(value) => handleInputChange("workPermits", value)}
            options={fifaCountries}
            placeholder="Select countries or type..."
            disabled={!isEditing}
            className="w-full"
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Contract Status
          </label>
          <StaffProfileDropdown
            value={formData.contractStatus}
            onChange={(value) => handleInputChange("contractStatus", value)}
            options={contractStatusOptions}
            placeholder="Select status"
            disabled={!isEditing}
          />
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Current club
          </label>
          <StaffProfileDropdownWithFreeText
            value={formData.currentClub}
            onChange={(value) => handleInputChange("currentClub", value)}
            options={clubOptions}
            placeholder="Select club or type..."
            disabled={!isEditing}
          />
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Contract Expiry Date
          </label>
          <CustomDateTimePicker
            value={formData.contractExpiryDate}
            onChange={(date) => handleInputChange("contractExpiryDate", date)}
            placeholder="Select expiry date"
            disabled={!isEditing}
            dateFormat="dd/MM/yyyy"
            className={`h-10`}
          />
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Willingness to relocate
          </label>
          <div className="flex space-x-6">
            {willingnessOptions?.map((option) => (
              <label key={option.value} className="flex items-center">
                <input
                  type="radio"
                  name="willingnessToRelocate"
                  value={option.value}
                  checked={formData.willingnessToRelocate === option.value}
                  onChange={() =>
                    handleInputChange("willingnessToRelocate", option.value)
                  }
                  disabled={!isEditing}
                  className="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 disabled:opacity-50"
                />
                <span className="ml-2 text-sm text-gray-700">
                  {option.label}
                </span>
              </label>
            ))}
          </div>
        </div>
        <div className="space-y-1">
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Preferred regions
          </label>
          <MultiSelectWithFreeText
            value={formData.preferredRegions}
            onChange={(value) => handleInputChange("preferredRegions", value)}
            options={regionOptions}
            placeholder="Select regions or type..."
            disabled={!isEditing}
            className="w-full"
          />
        </div>
      </div>
    </div>
  );
};

export default WorkPermissionsAvailabilitySection;
